import React from "react";
import "./HeroSection.css";

export default function HeroSection() {
  return (
    <div className="section-wrapper">
      {/* Left Red Section */}
      <div className="left-panel">
        <p className="intro-text">
          مصمم عناية يساعدك مهتم بتقديم نصائح خطوة بخطوة ومحتوى مفيد لكل من المبتدئين وأيضًا لمن لديهم خبرة.
          هدفي أن أنقل لك أفضل ما تعلمته وأن أكون شريك نجاح في بناء مهاراتك.
        </p>
      </div>

      {/* Right Section */}
      <div className="right-panel">


        <img
          src="/images/person1.png"
          alt="person"
          className="main-photo"
        />
      </div>
    </div>
  );
}

/* ---- HeroSection.css ----

*/
